module.exports = __webpack_public_path__ + "static/img/矿山全场景AI视频识别-case.310002e7.png";